import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Top from "../components/views/Top.vue";
import Ruri from "../components/views/Ruri.vue";
import Minato from "../components/views/Minato.vue";
import Yuu from "../components/views/Yuu.vue";
import Mikoto from "../components/views/Mikoto.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Top",
    component: Top,
    meta: { title: 'ラズベリーキューブASMR' }
  },
  {
    path: "/Ruri",
    name: "Ruri",
    component: Ruri,
    meta: { title: '桜庭・ヴィクトリア・瑠莉はエッチで天使でブライダル♪' }
  },
  {
    path: "/Minato",
    name: "Minato",
    component: Minato,
    meta: { title: '狩野みなとはおねだり上手なちゅき♡ちゅき♡ご奉仕わんこちゃん♪' }
  },
  {
    path: "/Yuu",
    name: "Yuu",
    component: Yuu,
    meta: { title: '結月悠は初心で乙女なちょろカワうさぎだぴょん♪' }
  },
  {
    path: "/Mikoto",
    name: "Mikoto",
    component: Mikoto,
    meta: { title: '海道美琴と行く癒しのおぎゃ甘ばぶばぶ温泉旅行♪' }
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router;
